import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import i18nHttpLoader from 'i18next-http-backend'
import Axios from 'axios'
import config from '@/config/env'

const { I18NEXTERNAL } = config

export const locales = [
  {
    value: 'es_ES',
    desc: 'LOCALE.SPANISH',
  },
  {
    value: 'pt_PT',
    desc: 'LOCALE.PORTUGUESE',
  },
  {
    value: 'en_EN',
    desc: 'LOCALE.ENGLISH',
  },
]
const initReactI8n = i18n.use(initReactI18next)
if (I18NEXTERNAL !== undefined && I18NEXTERNAL === 'true') {
  initReactI8n.use(i18nHttpLoader).init({
    lng: locales[0].value,
    fallbackLng: [locales[0].value],
    keySeparator: false,
    interpolation: {
      escapeValue: false,
    },
    react: {
      bindI18n: 'languageChanged',
      bindI18nStore: '',
      transEmptyNodeValue: '',
      transSupportBasicHtmlNodes: true,
      transKeepBasicHtmlNodesFor: ['br', 'strong', 'i'],
      useSuspense: false,
    },
    backend: {
      loadPath: window.location.protocol + '//' + window.location.host + '/assets/locales/{{lng}}.json',
      request: function (options, url, payload, callback) {
        Axios.get(url)
          .then((res) => {
            callback(null, { status: 200, data: res.data })
          })
          .catch((err) => callback(err))
      },
    },
  })
} else {
  const labelsES = require(`./pontio/locales/es.json`)
  const labelsEN = require(`./pontio/locales/en.json`)

  const errorsES = require(`./pontio/errors/es.json`)
  const errorsEN = require(`./pontio/errors/en.json`)
  const localesResource = [
    {
      value: 'es_ES',
      desc: 'LOCALE.SPANISH',
      json: { ...labelsES, ...errorsES },
    },
    {
      value: 'pt_PT',
      desc: 'LOCALE.PORTUGUESE',
      json: { ...labelsES, ...errorsES },
    },
    {
      value: 'en_EN',
      desc: 'LOCALE.ENGLISH',
      json: { ...labelsEN, ...errorsEN },
    },
  ]

  let language = {}
  localesResource.map((leng) => (language = { ...language, [leng.value]: { translation: leng.json } }))

  const resources = language
  initReactI8n.init({
    resources,
    lng: locales[0].value,
    fallbackLng: [locales[0].value],

    keySeparator: false,

    interpolation: {
      escapeValue: false,
    },
    transSupportBasicHtmlNodes: true,
    transKeepBasicHtmlNodesFor: ['br', 'strong', 'b'],
    react: {
      bindI18n: 'languageChanged',
      bindI18nStore: '',
      transEmptyNodeValue: '',
      transSupportBasicHtmlNodes: true,
      transKeepBasicHtmlNodesFor: ['br', 'strong', 'i'],
      useSuspense: true,
    },
  })
}
export default i18n
